import { render, staticRenderFns } from "./RoleEditAction.vue?vue&type=template&id=1729610d"
import script from "./RoleEditAction.vue?vue&type=script&lang=js"
export * from "./RoleEditAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports